import ImageContainer from "../../../components/general/ImageContainers/ImageContainer";
import List from "../../../components/general/List/List";
import ListItem, {
	type ListItemProps,
} from "../../../components/general/List/components/ListItem/ListItem";
import { getUrlFromStoryblokLink } from "../../../utils/storyblok/urls";
import { notUndefined } from "../../../utils/type-guards/general";

const NavListModule = ({ list_items }: Queries.NavListFragment) => {
	const listItemProps = list_items
		?.map<ListItemProps | undefined>((item) => {
			if (!item || !item.image || !item.image.filename) return;

			const url = getUrlFromStoryblokLink(item.link);
			return {
				variant: "standard",
				productTab: item.productTab ?? false,
				title: item.title ?? "",
				image: item.image.filename && (
					<ImageContainer
						alt={item.image.alt || item.title || item.text || undefined}
						imgSrc={item.image.filename}
						sizes="200px"
						hidePlaceholder
					/>
				),
				description: item.text ?? "",
				href: url,
				tag: item.tag ?? undefined,
			};
		})
		.filter(notUndefined);

	return (
		<List>
			{listItemProps?.map((list, index) => (
				<ListItem key={index} {...list} />
			))}
		</List>
	);
};
export default NavListModule;
